import React, { useEffect, useRef, useState } from 'react';
import ModuleCard from './ModuleCard';
import './CarouselSection.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const CarouselSection = ({ titulo, modulos, autoScroll = false }) => {
  const containerRef = useRef(null);
  const [showArrows, setShowArrows] = useState(false);
  const [isDark, setIsDark] = useState(document.body.classList.contains("dark-mode"));

  const scroll = (direction) => {
    const amount = 220;
    containerRef.current.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.body.classList.contains("dark-mode"));
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="carousel-section mb-4">
      <h3
        className="carousel-titulo"
        style={{ color: isDark ? '#ffffff' : '#111827' }}
      >
        {titulo}
      </h3>

      <div
        className="carousel-wrapper"
        onMouseEnter={() => setShowArrows(true)}
        onMouseLeave={() => setShowArrows(false)}
      >
        {/* Setas fora do fluxo de layout */}
        {showArrows && (
          <>
            <button className="nav-arrow left" onClick={() => scroll('left')}>
              <FaChevronLeft />
            </button>
            <button className="nav-arrow right" onClick={() => scroll('right')}>
              <FaChevronRight />
            </button>
          </>
        )}

        <div className="carousel-container" ref={containerRef}>
          {modulos.map((modulo, idx) => (
            <ModuleCard key={idx} {...modulo} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CarouselSection;
